import { render, staticRenderFns } from "./FundTypeModal.vue?vue&type=template&id=ae0b2514&"
import script from "./FundTypeModal.vue?vue&type=script&lang=js&"
export * from "./FundTypeModal.vue?vue&type=script&lang=js&"
import style0 from "./FundTypeModal.vue?vue&type=style&index=0&id=ae0b2514&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports